import React from "react";
import { useLanguage } from "@/App";
import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from "@/components/ui/accordion";

const FAQ = () => {
  const { t } = useLanguage();
  const faqItems = t("faq.items");

  return (
    <section
      id="faq"
      data-testid="faq-section"
      className="py-24 md:py-32 bg-[#0A0A0A]"
    >
      <div className="max-w-4xl mx-auto px-6 md:px-12">
        {/* Header */}
        <div className="mb-16">
          <p
            data-testid="faq-overline"
            className="text-xs font-bold uppercase tracking-[0.2em] text-zinc-500 mb-4"
          >
            {t("faq.overline")}
          </p>
          <h2
            data-testid="faq-title"
            className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white"
            style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
          >
            {t("faq.title")}
          </h2>
        </div>

        {/* FAQ Accordion */}
        <Accordion type="single" collapsible className="space-y-0">
          {faqItems.map((item, index) => (
            <AccordionItem
              key={index}
              value={`item-${index}`}
              data-testid={`faq-item-${index}`}
              className="border-b border-white/10 py-2"
            >
              <AccordionTrigger
                data-testid={`faq-trigger-${index}`}
                className="text-left text-lg font-semibold text-white hover:text-[#FF6B00] hover:no-underline py-6 [&[data-state=open]]:text-[#FF6B00]"
                style={{ fontFamily: "'Cabinet Grotesk', sans-serif" }}
              >
                {item.question}
              </AccordionTrigger>
              <AccordionContent
                data-testid={`faq-content-${index}`}
                className="text-zinc-400 leading-relaxed pb-6 pr-8"
              >
                {item.answer}
              </AccordionContent>
            </AccordionItem>
          ))}
        </Accordion>
      </div>
    </section>
  );
};

export default FAQ;
